import React, { useCallback, useState } from 'react';
import { isNil } from 'lodash';
import Button from '../../../../../components/Button';
import CountOfTotal from '../../../../../components/CountOfTotal';
import BaseForm from '../../../../../components/form/BaseForm';
import FileUploadForm from '../../../../../components/form/FileUploadForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Select from '../../../../../components/input/Select/Select';
import Panel from '../../../../../components/outline/Panel';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_MEMO,
  MINIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT,
  RECOMMEND_PRODUCT_TYPE,
  RECOMMEND_PRODUCT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/recommendProductConstants';
import { asyncSimpleModal } from '../../../../../lib/common';
import recommendProductSearchInfo from '../../../../../static/images/recommend/product/recommend-product-search-info.png';
import RecommendSearchInfoDrawer from '../../../common/RecommendSearchInfoDrawer';
import './RecommendProductDirectSaveInfo.scss';

const RecommendProductSaveInfo = (props) => {
  const { form, setData, recommendProductInfo, typeDisabled, onChangeAttachment } = props;
  const { type, memo } = recommendProductInfo;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawerVisible = useCallback(async () => {
    if (isNil(type)) {
      await asyncSimpleModal({
        title: '추천 상품 타입',
        type: 'error',
        message: '먼저 추천 상품 타입을 선택해주세요.',
      });

      return;
    }

    setDrawerVisible(!drawerVisible);
  }, [drawerVisible, type]);

  return (
    <Panel className="recommend-product-direct-save-info">
      <div className="panel-header">
        <div className="title">추천 상품 정보</div>
        {
          /**
           *  검색 추천에서만 설명이 노출이 되도록 함.
           */
          type === RECOMMEND_PRODUCT_TYPE.SEARCH_RECOMMEND && (
            <Button isRadius color="primary" text="설명보기" onClick={toggleDrawerVisible} />
          )
        }
      </div>

      <div className="panel-body">
        {/* 추천 상품 타입 */}
        <BaseForm
          label="추천 타입"
          content={
            <Select
              list={RECOMMEND_PRODUCT_TYPE_SELECT_LIST}
              onChange={(value) =>
                setData({
                  path: ['recommendProductSave', 'recommendProductInfo', 'type'],
                  value,
                })
              }
              defaultValue={type}
              value={type}
              disabled={typeDisabled}
              isTable={false}
            />
          }
        />

        {/* 메모 */}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_MEMO} />
            </span>
          }
          initialValue={memo}
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_MEMO}
          onChange={(value) =>
            setData({
              path: ['recommendProductSave', 'recommendProductInfo', 'memo'],
              value,
            })
          }
          name="memo"
          autoSize={{ minRows: 4, maxRows: 8 }}
        />

        <BaseForm
          label="첨부파일"
          content={
            <FileUploadForm
              files={recommendProductInfo.attachment}
              onChange={onChangeAttachment}
              deleteFile={() =>
                setData({ path: ['recommendProductSave', 'recommendProductInfo', 'attachment'], value: [] })
              }
              validExtension={['.xlsx']}
            />
          }
        />
      </div>

      <RecommendSearchInfoDrawer
        title="추천 상품"
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
        imgUrl={recommendProductSearchInfo}
      >
        <div>*앱에서 상품검색 탭에서 추천되는 상품 리스트입니다.</div>
        <div>
          *추천 상품 리스트는 최소 {MINIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[type]}개, 최대{' '}
          {MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[type]}개입니다.{' '}
        </div>
      </RecommendSearchInfoDrawer>
    </Panel>
  );
};

export default RecommendProductSaveInfo;
